<template>
    <div class="row">
        <div class="col-md-4 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Allergies</p>
                    </div>
                </div>
                <div class="row justify-content-center ">
                    <div class="col-md-12">
                        <ul class="list-group mb-3" v-if="als.length>0">
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0" v-for="a in als">
                                <div class="row">
                                    <div class="col-md-7 sb-list-fitem-regular">
                                        {{ a.all_sr ? a.all_srname : a.allergy_data.ald_name }}
                                    </div>
                                    <div class="col-md-3 text-right sb-list-sitem">
                                        <a href="#" class="text-danger" @click.prevent="deleteAlById(a)">
                                            Remove
                                        </a>
                                    </div>
                                    <div class="col-md-2 text-right sb-list-sitem">
                                        <a href="#" class="color-sky-blue-3" @click.prevent="show(a)">
                                            Edit
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title"><span v-if="update">Edit </span><span v-else>New </span>Allergy</p>
                    </div>
                </div>
                <div class="justify-content-center" v-if="update && al.id==''">
                    <div class="col-md-12 text-center pb-3">
                        <h5 class="mt-5 mb-5">SELECT ALLERGY TO EDIT</h5>
                    </div>
                </div>
                <div v-else class="justify-content-center">
                    <div class="col-md-12">
                        <div id="al-form">
                            <div class="form-group">
                                <label class="mb-0">What is your new allergy?</label>
                                <small class="form-text text-muted mb-2">Entering the first few letters of your new allergy will display a suggestion.</small>
                                <multiselect
                                        v-model="al.all_ald"
                                        track-by="ald_id"
                                        label="ald_name"
                                        placeholder="Type to search allergy"
                                        :searchable="true"
                                        :allow-empty="false"
                                        @search-change="asyncFindAllergues"
                                        :options="searchallergies"
                                        :taggable="true"
                                        @tag="addSrAll"
                                        tag-placeholder="Add new allergy"
                                >
                                    <template slot="noOptions">Please type to search</template>
                                </multiselect>
                            </div>
                            <div class="form-group">
                                <input type="hidden" name="all_id">
                                <input type="hidden" name="all_aldid">
                                <input type="hidden" name="all_srname">
                            </div>
                        </div>
                        <div class="text-right mb-3">
                            <button v-if="!update" type="button" class="btn btn-success" @click.prevent="saveAl">Add to My Allergies</button>
                            <button v-if="update" type="button" class="btn btn-success" @click.prevent="updateAl">Update My Allergy</button>
                            <br/>
                            <a href="/my-health" type="button" class="btn btn-outline-secondary mt-3">Cancel</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['allergies', 'methodtype'],
    mounted() {
        this.listAl();
        this.addScreenReaderLabelsToMultiSelects();
        this.update = this.methodtype !== 'add';
    },
    data() {
        return {
            route: '/api/allergies',
            update: false,
            searchallergies: [],
            al: {
                id: null,
                all_aldid: null,
                all_ald: null,
                all_srname: null
            },
            als: []
        }
    },
    methods: {
        addSrAll(tag) {
            this.al.all_srname = tag;
            this.al.all_ald = {
                ald_name: tag,
                ald_id: 0
            };
        },
        asyncFindAllergues(query) {
            if (query == '') {
                this.searchallergies = []
            } else {
                this.searchallergies = this.allergies
            }
            this._clearErrors()
        },
        saveAl() {
            // null error fix. This defers an empty input to server side validation.
            if (this.al.all_ald == null) {
                this.al.all_ald = {ald_id: null};
            }

            this.$http.post(this.route, {
                all_aldid: this.al.all_ald.ald_id,
                all_srname: this.al.all_srname,
            })
                .then(function (response) {
                    this._clearErrors();

                    this.listAl();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Allergy was created!'
                    });
                    this.al = {
                        id: '',
                        all_aldid: ''
                    };
                }, (response) => {
                    this._handleErrors(response.data, '#al-form')
                })
        },
        listAl() {
            this.$http.get(this.route)
                .then(function (response) {
                    this.als = response.data;
                    if(this.als.length > 0 && this.update) this.show(this.als[0])
                }, (response) => {
                    this._handleErrors(response.data, '#al-form')
                })
        },
        show(a) {
            this.update = true
            this.al = {
                id: a.all_id,
                all_ald: {
                    ald_id: a.all_aldid,
                    ald_name: a.all_sr ? a.all_srname : a.allergy_data.ald_name
                }
            };
        },
        updateAl() {
            this.$http.put(this.route, {
                all_id: this.al.id,
                all_aldid: this.al.all_ald.ald_id,
                all_srname: this.al.all_srname,
            })
                .then(function (response) {
                    this.listAl();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Allergy was updated!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#al-form')
                })
        },
        deleteAlById(al) {
            if (!confirm('Do you really want to delete this allergy?'))
                return

            this.$http.delete(this.route + '/' + al.all_id)
                .then(function (response) {
                    this.listAl();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Allergy was deleted!'
                    });
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#al-form')
                })
        },
        _handleErrors: function (items, selector) {
            this._clearErrors();

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    if (error === 'all_aldid' && items['errors'].hasOwnProperty('all_srname')) {
                        //both checks failed validation on backend, but we only need to display one
                        //because they are duplicate messages.
                        continue;
                    }
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        _clearErrors: function () {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()
        },
        addScreenReaderLabelsToMultiSelects() {
            $('.multiselect__tags:first').attr('aria-label', 'Search For Allergy');
        }
    }

}
</script>
